import LooksSimilarItemsFailure from "./LooksSimilarItemsFailure";
import { DISAPPOINTED } from "../../faceEmoji";
import { useRuntimeConstants } from "../../../context/runtimeConstants/RuntimeConstantsContext";

const LooksSimilarItemsFailed = () => {
  const { getTranslation } = useRuntimeConstants();
  return (
    <LooksSimilarItemsFailure
      titleTranslationKey="similar_items_fail_title"
      subTitleTranslationKey="similar_items_api_failure_subtitle"
      emojiType={DISAPPOINTED}
      ariaLabel={getTranslation("emoji_face_dissapointed")}
    ></LooksSimilarItemsFailure>
  );
};

export default LooksSimilarItemsFailed;
